import {
  getSelectedObjectsProperty,
} from './../utils/common';

// Template for the Dropdown
const multiSelectDropdownTemplate = `
<div uib-dropdown class="multi-select-dropdown  inlineBlock margin-r20 ui-select color-dropdown-ml" style="margin-left: 0;width: 100%;" >
  <style>
  .multi-select-dropdown .dropdown-toggle,
  .multi-select-dropdown .dropdown-toggle:active,  
  .multi-select-dropdown .dropdown-toggle:hover,
  .multi-select-dropdown .dropdown-button.dropdown-toggle:focus {
    border: none;
  }
  .dropdown-button{
    color: #242633;
    padding: 6px 10px 6px 10px;
    width: 100%;
    font-size: 14px;
    font-weight: inherit;
    letter-spacing: normal;
    text-transform: unset;
    border-color: transparent;
    margin: 0;
    text-align: left;
  }
  .dropdown-button:hover, .dropdown-button:focus, .dropdown-button:active {
    background-color: transparent;
    color: #242633;
  }
  .dropdown .locationsDropdown{
    max-height: 300px;
    width: 285px;
  }
  @media only screen and (min-width: 767px) and (max-width: 768px) {
    .dropdown .locationsDropdown{
      max-height: 300px;
      width: 245px;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .dropdown .locationsDropdown{
      max-height: 300px;
      width: 175px;
    }
  }
  .practice-area-list {
    padding-left: 38px;
    max-height: 220px;
    overflow-y: auto;
  }
  .practice-area-list li{
    padding: 2px 0;
  }
  </style>
  <div uib-dropdown>
    <button uib-dropdown-toggle id="{{buttonId}}" class="btn-noline-info btn-xs dropdown-button " type="button">
      {{placeholder}}
  </button>
    <div uib-dropdown-menu class="bootstrapDropdown locationsDropdown">
      <div class = "pull-right padding-b5">
      <button ng-click="selectAll()" class="btn btn-info btn-xs">Select All</button>
      <button ng-click="unselectAll()" class="btn btn-info btn-xs">Deselect All</button>
      </div>
      <br />

      <div class="" data-ng-repeat = "item in baseList | orderBy: 'value'">
        <label class="ui-checkbox margin-r10">
            <input type="checkbox" ng-click="selectItem(item)" data="{{value}}" ng-model="item.ticked">
            <span>{{item.name}}</span>
        </label>
      </div>
    </div>
  </div>
</div>
`;

// Controller for the dropdown directive
const multiSelectDropdownController = ($scope, $timeout, locationsService) => {
  const stopEventExecution = event => {
    event.stopPropagation();
  };

  $('.bootstrapDropdown').click(stopEventExecution);

  $scope.selectItem = (item) => {
    item.ticked = !item.ticked;
    $scope.onChange();
  }

  // Resets the selection of all
  $scope.unselectAll = () => {
    $scope.baseList.forEach(item => {
        item.ticked = false;
    })
    $scope.onChange();
  };

  $scope.selectAll = () => {
    $scope.baseList.forEach(item => {
        item.ticked = true;
    })
    $scope.onChange();
  };

};

// returns DDO for the dropdown
const multiSelectDropdown = () => {
  return {
    restrict: 'AE',
    scope: {
      buttonId: '@',
      placeholder: '=',
      baseList: '=',
      onChange: '&',
    },
    replace: true,
    template: multiSelectDropdownTemplate,
    controller: multiSelectDropdownController
  };
};

angular
.module('app.directives')
.directive('multiSelectDropdown', multiSelectDropdown)



// WEBPACK FOOTER //
// ./scripts/shared/directives/multi-select-dropdown.js